"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _jspdf = _interopRequireDefault(require("jspdf"));
var _default = exports.default = {
  install: function install(Vue, options) {
    Vue.prototype.exportPdfHandler = function (el, title, imgtype) {
      // el 要导出元素的id
      // title 文件名称
      // imgtype 图片类型 默认png
      var imgType = imgtype ? imgtype : "png";
      var element = document.getElementById(el);
      (0, _html2canvas.default)(element, {
        allowTaint: true
      }).then(function (canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        var pageHeight = contentWidth / 592.28 * 841.89;
        var leftHeight = contentHeight;
        var position = 0;
        var imgWidth = 595.28;
        var imgHeight = 592.28 / contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/' + imgType.toLowerCase(), 1.0);
        var PDF = new _jspdf.default('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, imgType.toUpperCase(), 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, imgType.toUpperCase(), 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + '.pdf');
        console.log('开始下载');
      });
    };
  }
};